import {Component, EventEmitter, Input, ViewChild, OnChanges, Output, SimpleChanges} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { IKpiPlannedEvents } from '../../../../services-api-v2/kpi-follow-up/models/process-events-and-t-class-blocks.model';
import { MatSort, Sort } from '@angular/material/sort';
import { TimezoneService } from 'app/shared/services/timezone/timezone.service';

@Component({
    selector: 'app-kpi-planned-events-list-table',
    templateUrl: './kpi-planned-events-list-table.component.html',
    styleUrls: ['./kpi-planned-events-list-table.component.scss'],
    standalone: false
})
export class KpiPlannedEventsListTableComponent implements OnChanges {
  @Input() events: IKpiPlannedEvents[];
  @Input() displayActionColumn: boolean;
  @Input() isProcessUnassigning: boolean;
  @Output() optionSelected: EventEmitter<any> = new EventEmitter();
  @ViewChild('sort', { static: false }) sort: MatSort;

  public dataSource: MatTableDataSource<IKpiPlannedEvents> = new MatTableDataSource<IKpiPlannedEvents>([]);
  public columnsToDisplay: string[] = [
    'parkName', 'turbineName', 'title', 'category', 'startTs', 'endTs', 'duration', 'productionLoss', 'revenueLoss', 'creationTs'
  ];
  public columnsToTranslate: string[] = [
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.PARK',
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.TURBINE',
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.EVENT_TITLE',
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.EVENT_CATEGORY',
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.START_TIME',
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.END_TIME',
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.DURATION_PLANNED',
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.PROD_LOSS_FORECAST',
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.REV_LOSS_FORECAST',
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.CREATED_ON'
  ];

  public optionsSelect = [
    'KPI.PORTFOLIO.PLANNED_EVENTS_TABLE.UNASSIGN_FROM_PROCESS'
  ];

  constructor(
    public tz: TimezoneService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.events && changes.events.currentValue) {
      this.dataSource = new MatTableDataSource(changes.events.currentValue);
      this.dataSource.sort = this.sort;
    }

    if (this.displayActionColumn) {
      if (this.columnsToDisplay.indexOf('actions') === -1) {
        this.columnsToDisplay.push('actions');
        this.columnsToTranslate.push('') // EMPTY FOR ACTIONS
      }
    }
  }

  private compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

   public sortData(sort: Sort) {
    const data = this.dataSource.data.slice();
    if (!sort.active || sort.direction === '') {
      return;
    }
    this.dataSource.data = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      if (sort.active) {
        return this.compare(a[sort.active], b[sort.active], isAsc)
      }
      return 0;
    });
  }

  public selectOption(data, element): void {
    this.optionSelected.emit({data, element})
  }
}
